export default "__VITE_ASSET__28uvSn6u__"